const messages = {
  "Algolia.GlobalSearch.Heading": "검색 결과",
  "Algolia.GlobalSearch.TextField.Placeholder": "무엇을 찾고 계시나요?",
  "Algolia.GlobalSearch.SearchButton.Text": "탐색",
  "Algolia.GlobalSearch.EventType.Label": "검색 결과",
  "Algolia.GlobalSearch.ItemsPerPage.Label": "페이지 당 항목",
  "Algolia.GlobalSearch.Meta.Text": "{count} 검색 결과",

  "Algolia.SearchPage.Heading": "해외 유학 프로그램 찾기",
  "Algolia.SearchPage.TextField.Placeholder": "키워드로 프로그램 검색",
  "Algolia.SearchPage.Filters.Label": "필터",
  "Algolia.SearchPage.ClearButton.Label": "모두 지우기",
  "Algolia.SearchPage.ProgramType.Label": "프로그램 종류",
  "Algolia.SearchPage.DeliveryMethod.Label": "전달 방법",
  "Algolia.SearchPage.HousingType.Label": "숙소 종류",
  "Algolia.SearchPage.AcademicLevel.Label": "학업 수준",
  "Algolia.SearchPage.UniversityName.Label": "대학 이름",
  "Algolia.SearchPage.Select.Placeholder": "입력 시작 또는 선택",
  "Algolia.SearchPage.UniversityRanking.Label": "대학 순위",
  "Algolia.SearchPage.AcademicDiscipline.Label": "학문 분야",
  "Algolia.SearchPage.Regions.Label": "지역",
  "Algolia.SearchPage.SubregionsCities.Label": "소도시와 도시",
  "Algolia.SearchPage.LanguageOfInstruction.Label": "수업 언어",
  "Algolia.SearchPage.languagePrerequisiteLevel.Label": "언어 요구 수준",
  "Algolia.SearchPage.GPARequirements.Label": "GPA 요구 수준",
  "Algolia.SearchPage.TermType.Label": "기간 유형",
  "Algolia.SearchPage.ProgramFees.Label": "프로그램 비용 더 알아보기",
  "Algolia.SearchPage.SearchButton.Title": "프로그램 검색",
  "Algolia.SearchPage.ResultsMeta": '{count} 개의 프로그램 결과',
  "Algolia.SearchPage.SortBy.Label": "정렬 기준",
  "Algolia.SearchPage.SortBy.Relevancy.option": "관련성",
  "Algolia.SearchPage.SortBy.Newest.option": "최신",
  "Algolia.SearchPage.CreditPrograms.Label": "학점 프로그램만 표시",
  "Algolia.SearchPage.HousingType.Tooltip": "특정 숙소 유형을 고려중이신가요? 여기에서 숙소 유형별로 필터링합니다.",
  "Algolia.SearchPage.languagePrerequisiteLevel.Tooltip": "언어 레벨에 적합한 프로그램을 찾고 계시나요? 여기에서 언어 수준을 필터링하십시오.",
  "Algolia.SearchPage.GPARequirements.Tooltip": "보유한 GPA에 적합한 프로그램을 찾고 계시나요? 여기에서 GPA 수준을 필터링합니다.",
  "Algolia.SearchPage.ProgramFees.Tooltip": "예산을 고민하고 계시나요? 여기에서 비용을 필터링합니다. 검색 범위를 넓히려면 둘 이상을 선택하세요.",

  "Pager.Current.MetaCurrent": "현재 페이지",
  "Pager.First.MetaFirst": "첫 페이지로 이동",
  "Pager.Last.MetaLast": "마지막 페이지로 이동",
  "Pager.Next.MetaTitle": "다음 페이지로 이동",
  "Pager.Next.TextFull": "다음 페이지",
  "Pager.Next.Text": "다음",
  "Pager.Page.MetaPageNumber": "{page} 페이지로 이동",
  "Pager.Page.VisuallyHidden": "페이지",
  "Pager.Previous.MetaTitle": "이전 페이지로 이동",
  "Pager.Previous.TextFull": "이전 페이지",
  "Pager.Previous.Text": "이전",

  "ProgramCard.Label.None": "없음",
  "ProgramCard.EstimatedCost.Label": "예상 비용",
  "ProgramCard.CTA.Label": "프로그램 세부 정보",
  "ProgramCard.GPARequirements.Label": "학점 요구 사항",
  "ProgramCard.LanguageOfInstruction.Label": "수업 언어",
  "ProgramCard.LanguageRequirements.Label": "언어 요구 사항",
  "ProgramCard.Status.Label": "프로그램 일시 중단됨",

  "ProgramQuickView.Length.Label": "길이",
  "ProgramQuickView.Options.Label": "전달 방법",
  "ProgramQuickView.ReadMore.CTA": "더 읽어보기",
  "ProgramQuickView.ProgramDetails.CTA": "프로그램 세부 정보 보기",
  "ProgramQuickView.ApplyNow.CTA": "지원하기",
  "ProgramQuickView.AtGlance.Label": "한눈에 보기",
  "ProgramQuickView.LanguageInstruction.Label": "수업 언어",
  "ProgramQuickView.LanguageRequirements.Label": "언어 요구 사항",
  "ProgramQuickView.languagePrerequisiteLevel.Label": "언어 요구 수준",
  "ProgramQuickView.GPA.Label": "학점 요구 사항",
  "ProgramQuickView.AcademicLevel.Label": "학업 수준",
  "ProgramQuickView.Credits.Label": "학점",
  "ProgramQuickView.AcademicStrengths.Label": "학업 강도",
  "ProgramQuickView.Housing.Label": "숙소",
  "ProgramQuickView.Internship.Label": "파트타임 인턴십(옵션)",
  "ProgramQuickView.Visa.Label": "비자 요구됨",

  "ProgramSelector.BlockTitle": "나에게 딱 맞는 프로그램 찾기",
  "ProgramSelector.BlockDescription": "유학을 선택할 때 지역, 대학, 특정한 프로그램 중 어떤 부분을 고려하나요?",
  "ProgramSelector.BlockLink": "또는 전체 프로그램 탐색하기",
  "ProgramSelector.Destinations.BlockDescription": "관심 지역을 선택하세요.",
  "ProgramSelector.Destinations.BlockQuestion": "어디서 공부하고 싶으신가요?",
  "ProgramSelector.Destinations.AllDestinations.Label": "모든 유학 장소",
  "ProgramSelector.Destinations.Destinations.Label": "지역",
  "ProgramSelector.Universities.BlockDescription": "흥미로운 대학을 모두 선택하세요.",
  "ProgramSelector.Universities.BlockQuestion": "어느 대학에서 공부하고 싶으신가요?",
  "ProgramSelector.Universities.Universities.Label": "대학",
  "ProgramSelector.TypeOfStudy.TypeOfStudy.Label": "유학 프로그램",
  "ProgramSelector.TypeOfStudy.BlockDescription": "흥미로운 공부 타입을 모두 선택하세요.",
  "ProgramSelector.TypeOfStudy.BlockQuestion": "어떤 프로그램 종류가 마음에 드시나요?",
  "ProgramSelector.SeePrograms.Label": "내 프로그램 보기",
  "ProgramSelector.BrowsePrograms.Label": "또는 전체 프로그램 탐색하기",

  "Algolia.SidebarFilters.SelectOrRadios.FirstOption": "모든 나라",
  "Algolia.SearchPage.GPARequirements.Options.None": "없음",
}

export default messages;
